'use client';

import React from 'react';
import { List, ListItem } from '@mui/material';
import Link from 'next/link';
import cn from './style.module.scss';
interface NavigationItem {
  url: string;
  label: string;
}
interface WimbledonNavigationProps {
  navigationItems: NavigationItem[];
}
export default function WimbledonNavigation({
  navigationItems,
}: WimbledonNavigationProps) {
  return (
    <List className={cn.wimbledonNavigationList}>
      {navigationItems.map((item: NavigationItem, index: number) => (
        <ListItem key={index} className={cn.wimbledonNavigationItem}>
          <Link className={cn.wimbledonNavigationLink} href={item.url}>
            {item.label}
          </Link>
        </ListItem>
      ))}
    </List>
  );
}
